// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__f6bD4","title":"style_title__xcdIQ","parentGroupName":"style_parentGroupName__xZ7on"};